/**
 * O rodapé que fecha cada aba de Manutenções.
 *
 * Papel: reproduz `footer.hint` (l. 368, 638) — mono 11 px, `--texto-fraco`,
 * centralizado, 14 px abaixo da tabela — com o texto que continua verdadeiro:
 * "Dados salvos automaticamente.", sem o "no navegador (localStorage)" da
 * origem.
 *
 * Como usar: a página põe o rodapé no fim do painel de cada aba; como só a aba
 * ativa aparece, ele se vê uma vez, igual nas três, como na origem, onde ele
 * fica abaixo das três seções. No papel do Dashboard ele some, como na origem
 * (l. 422).
 */

/**
 * O rodapé.
 *
 * @returns O texto do rodapé.
 */
export function RodapeDoMiolo() {
  return (
    <footer className="mt-3.5 text-center font-mono text-[11px] text-texto-fraco print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:hidden">
      Dados salvos automaticamente.
    </footer>
  );
}
